// src/components/SettingsModal.jsx
import React from 'react';
import { FaTimes } from 'react-icons/fa';
import SettingsForm from './SettingsForm.jsx';
import './SettingsModal.css';

export default function SettingsModal({ open, onClose }) {
  if (!open) return null;
  const stop = (e) => e.stopPropagation();
  return (
    <div className="modal-backdrop" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label="User Settings">
      <div className="modal" onClick={stop} style={{ maxWidth: 560 }}>
        <div className="modal-header">
          <h2>User Settings</h2>
          <button className="icon-button" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </div>
        <div className="modal-body">
          <SettingsForm asModal onClose={onClose} onSaved={onClose} />
        </div>
      </div>
    </div>
  );
}
